import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import clsx from "clsx";
import { registerLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import ru from "date-fns/locale/ru";

import InputNumber from "../../custom/numberInput/NumberInput";

import { reducerTest } from '../../../redux/reducer/employees/reducers/profileEmployee';
import { reducerEmployeeStatus } from '../../../redux/reducer/employees/reducers/employeesList';

import { AppDispatch } from '../../../redux/reducer/store';

import "react-datepicker/dist/react-datepicker.css";
import styles from '../headerBtn.module.scss';

const ChangeEmployeePaySection = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { inputTest } = useSelector((state: any) => state.employees.profileEmployees);

  const [error, setError] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useEffect(() => {
    registerLocale("ru", ru);
  }, []);

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(reducerTest({ type: '1', [name]: value }));
  };

  const handleDatePickerChange = (date: Date) => {
    if (date > new Date()) {
      setSelectedDate(date);
      setError(null);
      dispatch(reducerEmployeeStatus(null));
    } else {
      setError('date');
      dispatch(reducerEmployeeStatus(0));
    }
  };

  const handleClearDate = () => {
    if (selectedDate) {
      setSelectedDate(null);
    }
  };

  return (
    <div className={styles.settings__content_block}>
      <div className={styles.settings__block_info}>
        <div className={clsx(styles.check__list_block, styles.check__list_blockRight)}>
          <div className={styles.limit__block}>
            <span>Оклад:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'salary' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="salary"
              />
              {error && error === 'salary' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Дополнительные выплаты:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'additionalPayments' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="additionalPayments"
              />
              {error && error === 'additionalPayments' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Стоимость часа:</span>
            <div className={styles.error__input_block}>
              <InputNumber
                handleInputChange={handleChangeInput}
                reducer={reducerTest}
                inputValues={inputTest}
                editVacancy={true}
                name="costPerHour"
                styleName="limit__input"
                style={{ margin: '0' }}
              />
              {error && error === 'costPerHour' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Бонус 1:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'bonus1' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="bonus1"
              />
              {error && error === 'bonus1' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Бонус 2:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'bonus2' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="bonus2"
              />
              {error && error === 'bonus2' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Бонус 3:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'bonus3' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="bonus3"
              />
              {error && error === 'bonus3' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Компенсация авто:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'avto' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="avto"
              />
              {error && error === 'avto' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.limit__block}>
            <span>Компенсация связи:</span>
            <div className={styles.error__input_block}>
              <input
                type="number"
                className={error && error === 'connection' ? styles.error__input : styles.limit__input}
                onChange={handleChangeInput}
                defaultValue={0}
                name="connection"
              />
              {error && error === 'connection' && <span className={styles.error}>{error}</span>}
            </div>
          </div>
          <div className={styles.copy__block}>
            <span>Дата изменения:</span>
            <div className={clsx(styles.copy__data_picker, styles.copy__data_picker_small, error === 'date' && styles.error__reason_select)} >
              <DatePicker
                dateFormat="dd.MM.yyyy"
                placeholderText="Выберите дату"
                selected={selectedDate}
                locale={ru}
                name="date"
                onChange={handleDatePickerChange}
              />
              {selectedDate && (
                <div className={styles.clear__date_icon} onClick={handleClearDate} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangeEmployeePaySection;